import { render } from "./ServicesOverview.vue?vue&type=template&id=07d3a4d8"
import script from "./ServicesOverview.vue?vue&type=script&lang=js"
export * from "./ServicesOverview.vue?vue&type=script&lang=js"

import "./ServicesOverview.vue?vue&type=style&index=0&id=07d3a4d8&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__